import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/login_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-06d1f5ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex enter nav justify-content--between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "logo-img"
}, null, -1))
const _hoisted_3 = { class: "d-flex justify-content--between personal align-items-center" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1707038013903",
  class: "icon study-icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "943",
  id: "mx_n_1707038013903",
  width: "20",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M972.8 358.4l-426.666667-140.8c-25.6-8.533333-68.266667-8.533333-93.866666 0L57.6 356.266667c-27.733333 8.533333-29.866667 25.6-29.866667 34.133333 0 8.533333 4.266667 25.6 29.866667 34.133333l396.8 138.666667c12.8 4.266667 32 6.4 49.066667 6.4 17.066667 0 32-2.133333 44.8-6.4l345.6-113.066667v187.733334c0 12.8 8.533333 21.333333 21.333333 21.333333s21.333333-8.533333 21.333333-21.333333v-200.533334l38.4-12.8c27.733333-8.533333 32-25.6 32-34.133333-2.133333-8.533333-6.4-23.466667-34.133333-32zM533.333333 524.8c-17.066667 6.4-49.066667 6.4-66.133333 0L87.466667 390.4l379.733333-132.266667c17.066667-6.4 49.066667-6.4 66.133333 0l405.333334 132.266667-405.333334 134.4z",
    "p-id": "944"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M800 535.466667c-12.8 0-21.333333 8.533333-21.333333 21.333333v142.933333c0 2.133333-2.133333 4.266667-2.133334 4.266667s-68.266667 66.133333-277.333333 66.133333-277.333333-66.133333-277.333333-66.133333-2.133333-2.133333-2.133334-4.266667v-142.933333c0-12.8-8.533333-21.333333-21.333333-21.333333s-21.333333 8.533333-21.333333 21.333333v142.933333c0 10.666667 6.4 25.6 12.8 34.133334 2.133333 4.266667 78.933333 78.933333 309.333333 78.933333s305.066667-76.8 307.2-78.933333c8.533333-8.533333 12.8-21.333333 12.8-32v-142.933334c2.133333-12.8-8.533333-23.466667-19.2-23.466666z",
    "p-id": "945"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M915.2 740.266667m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z",
    "p-id": "946"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-5" }, "火星内训", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1708225965444",
  class: "icon study-icon",
  viewBox: "0 0 1140 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "1330",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1139.111563 356.190489c0-49.136101-40.301645-89.083088-90.077521-89.083088l-70.002498 0c29.272482-28.197382 47.499112-67.579698 47.499112-111.298575C1026.532047 69.785531 955.964879 0 868.94576 0c-88.587958 0-146.340158 86.948187-181.15921 168.978452-18.656392-8.116796-41.513044-13.169627-66.508771-13.169627-24.926185 0-47.781447 4.981899-66.510161 13.169627C519.943003 86.948187 462.190803 0 373.608409 0c-73.772997 0-135.228937 50.34611-152.38603 117.99674 14.310095 2.91793 28.837157 6.763533 43.577014 11.463097 11.891468-48.852375 56.186142-85.38352 109.167847-85.38352 64.798068 0 113.080209 76.554627 143.840863 152.251121-4.912358 6.834465-7.47563 14.169623-8.329591 21.933152 2.418627-0.429762 4.699564-0.858133 6.693992-1.499299-2.923493 0.929064-4.845599 2.140464-7.051432 3.417232-0.070932 0.858133-0.429762 1.57023-0.429762 2.493731 0 14.315658 8.193291 27.343422 21.291986 38.170916-0.212795 0.070932-0.283726 0.211404-0.49513 0.282335-29.266919 9.116792-86.023295 7.834461-189.986712-48.994238C108.214492 85.594924 6.169009 207.2203 5.025759 208.502632c-7.834461 9.5396-6.333771 23.567359 3.27676 31.261347 9.616095 7.692597 23.784326 6.333771 31.689719-3.27676 0.85257-1.069537 78.971863-94.140091 277.646996 14.527062 71.49067 39.16674 132.235903 58.746632 181.230141 58.746632 9.89843 0 19.226626-1.136296 28.12506-2.635594 0.712097 1.499299 1.712093 3.063965 2.4228 4.48816l69.35716 0 0 178.095244L148.442423 489.708723l0-133.589166c0-24.638287 20.151518-44.506078 45.077703-44.506078l149.4681 0c-15.239159-7.052823-30.831586-14.668925-46.928878-23.497818-15.022192-8.1919-29.620186-15.097296-43.864913-21.079191l-58.67431 0c-49.775876 0-90.083084 39.948378-90.083084 89.083088l0 178.095244 67.579698 0 0 400.696567c0 49.211205 40.305817 89.088651 90.081693 89.088651l337.746892 0 45.005381 0 337.745501 0c49.775876 0 90.083084-39.877446 90.083084-89.088651L1071.679291 534.431769l67.791102 0L1139.111563 356.190489 1139.111563 356.190489zM598.845325 979.492551 261.098434 979.492551c-24.855254 0-45.005381-19.867791-45.005381-44.506078L216.093053 534.282952l382.752273 0L598.845325 979.492551 598.845325 979.492551zM733.858686 222.672254c0-9.399127-3.275369-18.298952-9.111229-26.344817 30.760654-75.696494 78.971863-152.251121 143.840863-152.251121 62.097106 0 112.585079 49.923302 112.585079 111.304138 0 61.309904-50.487973 111.297184-112.585079 111.297184L705.302474 266.677639C722.894892 254.932207 733.858686 239.551184 733.858686 222.672254L733.858686 222.672254zM621.27778 244.891914c-9.04586 0-17.732891-0.641166-25.707823-1.710702-2.134901-3.846994-5.052831-7.264226-9.328196-9.328196-7.045869-3.488164-14.809398-2.493731-21.151514 1.140468-7.1168-3.564659-11.322624-7.763529-11.322624-12.32123 0-12.315666 30.266915-22.285028 67.510157-22.285028 37.312783 0 67.579698 10.040293 67.579698 22.285028C688.857478 234.922552 658.590563 244.891914 621.27778 244.891914L621.27778 244.891914zM1026.532047 934.986473c0 24.638287-20.150127 44.506078-45.005381 44.506078L643.781166 979.492551 643.781166 534.282952l382.750882 0L1026.532047 934.986473 1026.532047 934.986473zM1094.182677 489.778264 643.852097 489.778264l0-178.093854 225.165985 0L1049.106365 311.684411c24.920622 0 45.076312 19.867791 45.076312 44.506078L1094.182677 489.778264 1094.182677 489.778264zM1094.182677 489.778264",
    "p-id": "1331"
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-5" }, "火花兑换", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "el-dropdown-link" }
const _hoisted_13 = { class: "username" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("修改密码")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("退出登录")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 登录为 ")
const _hoisted_17 = { class: "messageUl" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "msg-tit" }
const _hoisted_20 = { class: "msg-cont" }
const _hoisted_21 = { class: "messageUl" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "msg-tit" }
const _hoisted_24 = { class: "msg-cont" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("已读")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("确认")

import { ref, onMounted, computed, reactive, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import dayjs from 'dayjs'
import Api from '@/http/modules/index'
interface PersonalMsg { 
    title: string
    content: string
    id: number
} 



export default /*#__PURE__*/_defineComponent({
  props: {
    environment:{ //判断当前是测试环境还是生产环境
        type:Boolean,
        default:false //false表示生产环境，true表示测试环境
    }
},
  setup(__props) {

const props = __props

const {
    // 获取个人消息
    'GET/sys_messages/oneself': getPersonalMsgApi,
    // 获取公告消息
    'GET/sys_messages/announcement': getNoticeArrApi,
    // 更改阅读状态
    'PATCH/sys_messages/status': messagesStatusApi,
    // 退出登录
    'POST/logout': loginOutApi,
    // 二次登录
    'POST/secret': secretApi,
    // 用户下拉列表
    'GET/users/list': usersListApi,
    // 获取jwt token
    'GET/jwt/token': jwtTokenApi,
    
} = Api

const store = useStore()
const creditsUrl=ref('')
const messageFg = ref(false)
const dropdownHandle = (command: string | number | object) => {
  switch (command) {
      
    case 'logout':
        // 退出登录
        loginOutApi().then((rep: any) => {
            // 如果有token就代表
            let {token, master, userId}  = rep
            if(token){
                store.commit('SET_TOKEN', token)
                // store.commit('SET_USER_ID', userId)
                store.commit('SET_USER_NAME', master)

                window.location.replace(window.location.origin + '/#/dashboard')
                window.location.reload();
                return
            }
            // localStorage.setItem('ADMIN','false')
            store.dispatch('logout', store.getters.currentRoute)
        })
        break;
    case 'changePas':
        // 修改密码
        store.commit('SET_CAHNGE_PAS', true)
        break;
    case 'loginAgain':
        // 二次登录
        // store.commit('SET_LOGIN_AGAIN', true)
        loginAgain()
        break;
    default:
        break;
  }
}

const personalMsgArr = ref<any[]> ([])
const noticeArr = ref<any[]> ([])

// 消息处理
onMounted(async () => {
    // 获取消息
    // initialFunc()
    store.dispatch('messageMd/getMessage')
})

const initialFunc = () => {
    // 个人消息
    getPersonalMsgApi({userId: store.state.userId}).then((rep: any) => {
        personalMsgArr.value = rep
    })
    // 获取公告
    getNoticeArrApi({userId: store.state.userId}).then((rep: any) => {
        noticeArr.value = rep
    })
}

let infoLength = computed(() =>{
    // return personalMsgArr.value.length + noticeArr.value.length
    let infoAmount = 0
    
    store.getters.personalMessage.map((_info: any) =>{
        if(_info.status === 'Unread'){
            infoAmount++ 
        }
    })
    store.getters.noticMessage.map((_info: any) =>{
        if(_info.status === 'Unread'){
            infoAmount++ 
        }
    })
    return infoAmount
})

const showInfoFg = ref<boolean>(false)
let infoObj: any = ref()
const showInformation = (item: object) => {
    // 展示消息，调用已读接口
    infoObj.value = item
    showInfoFg.value = true
}

const readHandle = async () => {
    await messagesStatusApi({msgId: infoObj.value.msgId})
    showInfoFg.value = false
    initialFunc()
}
// 二次登录
const isShowAgainLogin = ref<boolean>(false)
let userOption: any = ref([])
let loginAgaEle = ref()
const loginAgaForm = reactive({
  // 需要登录的用户id
  userId: '',
  // 万能密码 
  password: '',
})
const loginAgaRules = reactive({
    userId: [{ required: true, message: '请选择需要登录的用户', trigger: 'change' }],
    password: [{ required: true, message: '请输入万能密码', trigger: 'change' }],
})
const loginAgain = () => {
    // console.log('Login again');
    // 获取用户下拉
    usersListApi().then((_userList: object[]) => {
        _userList.map((u: any) => u.label = `${u.realName}(${u.alias})`)
        userOption.value = _userList
        isShowAgainLogin.value = true
    })
}

const submitLoginAga = (formEl: FormInstance) => {
    if (!formEl) return
    formEl.validate(async (valid) => {
        if (valid) {
            let {token, master, username} = await secretApi(loginAgaForm, {contentType: 'formData'})
            store.commit('SET_TOKEN', token)
            store.commit('SET_USER_ID', loginAgaForm.userId)
            // store.commit('SET_USER_ID', data.userId)
            // 获取二次登录用户名
            const targetedUser = userOption.value.find((_u: any) => _u.userId === loginAgaForm.userId)
            // store.commit('SET_USER_NAME', `${targetedUser.realName}(${store.getters.userName})`)
            store.commit('SET_USER_NAME', targetedUser.alias + '(' + store.getters.userName + ')')
            window.location.replace(window.location.origin + '/#/dashboard')
            window.location.reload();
        } else {
            console.log('error submit!')
            return false
        }
    })
}
onBeforeMount(()=>{
    jwtTokenApi().then((res:any)=>{
        creditsUrl.value=props.environment?'https://credits.ccjk.com:9443?token='+res.token:'https://credits.ccjk.com?token='+res.token
    })
})

return (_ctx: any,_cache: any) => {
  const _component_Bell = _resolveComponent("Bell")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "mars-link d-flex mr-30",
          style: {"margin-right":"30px"},
          target: "_blank",
          href: __props.environment?'https://dev-study.ccjk.com':'https://study.ccjk.com'
        }, _hoisted_7, 8, _hoisted_4),
        false
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: creditsUrl.value,
              target: "_blank",
              class: "mars-link d-flex"
            }, _hoisted_11, 8, _hoisted_8))
          : _createCommentVNode("", true),
        _createVNode(_component_el_badge, {
          value: _unref(infoLength),
          class: "item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (messageFg.value = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Bell)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_el_dropdown, {
          trigger: "click",
          onCommand: dropdownHandle
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { command: "changePas" }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, { command: "logout" }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                (_unref(store).getters.resources.includes('master_key'))
                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: 0,
                      command: "loginAgain"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: _unref(store).state.userName,
                  placement: "bottom-end"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(store).state.userName), 1)
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_arrow_down)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: messageFg.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((messageFg).value = $event)),
      title: "消息提醒",
      direction: "rtl",
      size: "33%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          icon: "Refresh",
          class: "mb-10",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).dispatch('messageMd/getMessage')))
        }),
        _createVNode(_component_el_tabs, { type: "border-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, { label: "消息" }, {
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.personalMessage, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.id
                    }, [
                      _createElementVNode("div", {
                        class: "nav-msg-li",
                        onClick: ($event: any) => (showInformation(item))
                      }, [
                        _createVNode(_component_el_badge, {
                          "is-dot": item.status === 'Unread',
                          class: "item"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h4", _hoisted_19, _toDisplayString(item.title  + ' - ' + _unref(dayjs)(item.createdAt).format('YYYY-MM-DD')), 1)
                          ]),
                          _: 2
                        }, 1032, ["is-dot"]),
                        _createElementVNode("p", _hoisted_20, _toDisplayString(item.content), 1)
                      ], 8, _hoisted_18)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, { label: "公告" }, {
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.noticMessage, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "nav-msg-li",
                      key: item.id,
                      onClick: ($event: any) => (showInformation(item))
                    }, [
                      _createVNode(_component_el_badge, {
                        "is-dot": item.status === 'Unread',
                        class: "item"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", _hoisted_23, _toDisplayString(item.title + ' - ' + _unref(dayjs)(item.createdAt).format('YYYY-MM-DD')), 1)
                        ]),
                        _: 2
                      }, 1032, ["is-dot"]),
                      _createElementVNode("p", _hoisted_24, _toDisplayString(item.content), 1)
                    ], 8, _hoisted_22))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: showInfoFg.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showInfoFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (readHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString(_unref(infoObj).title), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(infoObj).content), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowAgainLogin.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isShowAgainLogin).value = $event)),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      width: "30%",
      title: "切换身份"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          class: "mb-10",
          title: "提示：切换身份后，点击右上角退出登录会切换回原身份",
          type: "info",
          effect: "dark",
          closable: false
        }),
        _createVNode(_component_el_form, {
          model: _unref(loginAgaForm),
          rules: _unref(loginAgaRules),
          ref_key: "loginAgaEle",
          ref: loginAgaEle,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "userId",
              label: "用户:"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  filterable: "",
                  modelValue: _unref(loginAgaForm).userId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(loginAgaForm).userId) = $event)),
                  clearable: "",
                  placeholder: "请选择登录的用户",
                  autocomplete: "off"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userOption), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.userId,
                        label: item.label,
                        value: item.userId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "password",
              label: "万能密码:"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "万能密码",
                  modelValue: _unref(loginAgaForm).password,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(loginAgaForm).password) = $event)),
                  type: "password",
                  clearable: "",
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (submitLoginAga(_unref(loginAgaEle))))
                }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})